import React from 'react'
import { Grid, Typography, Card, CardContent, CardActions, Button } from '@mui/material'

function PartnershipCard(props) {
    const { src, orgName, link } = props
  return (
    <Grid item>
        <Card raised sx={{ width: {xs:345}, height:'100%', backgroundColor:'#262A34', color:'inherit' }}>
            <img src={src} style={{width:'100%', aspectRatio:'3/2', objectFit:'contain', backgroundColor: 'grey'}}/>
            {/* <CardMedia
            sx={{backgroundColor:'white', objectFit:'cover'}}
            component="img"
            height="140"
            image={oneHundredBlackMen}
            /> */}
            <CardContent>
                <Typography color='inherit' gutterBottom variant="h6" fontWeight='bold'>
                    {orgName}
                </Typography>
            </CardContent>
            <CardActions sx={{display:'flex', alignSelf:'flex-end'}}>
                <Button variant='contained' href={link} target='_blank' sx={{backgroundColor:'#36BAFE'}}>
                    <Typography variant="body3" fontWeight='bold' >
                        LEARN MORE
                    </Typography> 
                </Button>                                
            </CardActions> 
        </Card>
    </Grid>
  )
}

export default PartnershipCard